import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "./EventBus";
import { Coord } from "../../../../../src/types/Interface";
import calcGuideLinePoints from "../helpers/calcGuideLinePoints";


export default class LineManager {
  private isSuppMode: boolean = false;
  lines = Array(4).fill("").map(_ => new Line());
  guideLine1 = new Line({ width: 3 });
  guideLine2 = new Line({ width: 3 });

  constructor() {
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll());
    eventBus.on(EnumEventBus.supplementaryMode, (v: boolean) => this.isSuppMode = v);
  }
  clearAll = () => [...this.lines, this.guideLine1, this.guideLine2].forEach(l => l.clear());
  draw([p1, p2, p3, p4]: Coord[]) {
    this.drawLines([p1, p2, p3, p4]);
    this.isSuppMode && this.drawGuideLines([p1, p2, p3, p4])
  }
  drawLines(points: Coord[]) {
    const getSecCoord = (li: number) => points[li + 1 !== this.lines.length ? li + 1 : 0];
    this.lines.forEach((l, li) => l.draw(points[li], getSecCoord(li)));
  }
  drawGuideLines([p1, p2, p3, p4]: Coord[]) {
    const gl1 = calcGuideLinePoints(p2, p3, 120);
    const gl2 = calcGuideLinePoints(p3, p2, 120);
    this.guideLine1.draw(gl1[0], gl1[1]);
    this.guideLine2.draw(gl2[0], gl2[1]);
  }
  getGuideLinesCoords([p1, p2, p3, p4]: Coord[]) {
    return [calcGuideLinePoints(p2, p3, 120), calcGuideLinePoints(p3, p2, 120)]
  }
}